import type { GModalRenameInitialValues } from '../types';

import { useGModalContext, ModalType } from '~/presentation/ui';
import { useState } from 'react';

interface UseGModalRenameProps {
  onSuccess?: (data: GModalRenameInitialValues) => Promise<void>;
}

export const useGModalRename = (params?: UseGModalRenameProps) => {
  const { onOpenModal, initialValues, onCloseModal } = useGModalContext<ModalType.RENAME>();
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenRenameModal = (data: GModalRenameInitialValues) => {
    onOpenModal(ModalType.RENAME, data);
  };

  const handleRename = async () => {
    if (!initialValues) {
      throw new Error('initialValues is required');
    }

    setIsLoading(true);
    try {
      await params?.onSuccess?.(initialValues);
    } finally {
      setIsLoading(false);
      onCloseModal();
    }
  };

  return {
    isLoading,
    initialValues,
    handleRename,
    handleOpenRenameModal,
  };
};
